// Typed wrapper around `QueryClient.invalidateQueries` for the
// projects domain. Mirrors `visibility-invalidation.ts` — the wrapper
// accepts ONLY `PrefixQueryKey`, so the filter-included-key regression
// from #890 stays a compile error in the projects slice the same way
// it does for visibility.
//
// The projects slice has no filtered keys today (both `list()` and
// `detail(id)` are already prefix-depth), so the wrapper mostly
// exists to keep the call-site convention uniform with visibility and
// to keep direct `qc.invalidateQueries({ queryKey: projectKeys.* })`
// calls out of consumer code.

import type { QueryClient } from "@tanstack/react-query";
import type { PrefixQueryKey } from "./queryKeys";

/**
 * Invalidate a projects-domain query slice by prefix key.
 *
 * Returns the same `Promise<void>` that `queryClient.invalidateQueries`
 * returns, so callers can `await` it when ordering matters (e.g.
 * waiting for a refetch before navigating away).
 */
export function invalidateProjects(
  queryClient: QueryClient,
  prefixKey: PrefixQueryKey,
): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: prefixKey });
}
